import { Injectable } from '@angular/core';
import { ApiCallContext, FileObject } from '@safarilaw-webapp/shared/common-objects-models';
import { ApiDataAdapter, SafariRequired } from './adapter';

/**
 * FileObjectAdapter is used to do any last-minute transormations of FileObject's formValues
 * (for example toApiDate calls, or any other low-level transformations beofe sending to the API).
 * It only supports Create (POST) and Update (PUT) operations as File can only be created or updated.
 * The exact function depends on whatever the API gives us but these are the only two operations.
 *
 * Deleting a file is just a normal delete operation, and reading a file is done by creating templinks,
 * which is a different operation, so there are no adapter functions for those.
 *
 * Default implementation does nothing, but you can override it in your app to do any transformations you need.
 * Example in the function comments
 */
@Injectable({
  providedIn: 'root'
})
export class FileObjectAdapter extends ApiDataAdapter<FileObject> {
  toCreateModel(model: FileObject, context?: ApiCallContext<any>): SafariRequired<Map<string, string | number>> {
    const formValues = new Map<string, string>();
    formValues.set('name', model.name);
    return formValues;

    /**
     * Example of a transformation by a child class that extends this class:
     * toCreateModel(model: FileObject, context?: ApiCallContext<any>): SafariRequired<Map<string, string>> {
     *  const formValues = super.toCreateModel(model, context);
     *    formValues.set('someValue', transformSomething(model.someValue));
     *  return formValues;
     * }
     */
  }

  toUpdateModel(model: FileObject, context?: ApiCallContext<any>): SafariRequired<Map<string, string | number>> {
    const formValues = new Map<string, string>();
    if (model.name) {
      formValues.set('name', model.name);
    }

    return formValues;
    /**
     * Example of a transformation by a child class that extends this class:
     * toCreateModel(model: FileObject, context?: ApiCallContext<any>): SafariRequired<Map<string, string>> {
     *  const formValues = super.toUpdateModel(model, context);
     *  formValues.set('someValue', transformSomething(model.someValue));
     *  return formValues;
     * }
     */
  }
}
